<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-16 16:43:51
 * @Description: 近一月碳减排趋势
 * @FilePath: \fuzhou\src\module\overview\stationChargeModal\components\recentMonthCarbon.vue
-->
<template>
  <div class="recent-month-carbon">
    <pub-info-title :title="'近1月碳减排趋势'" :isModal="true" />
    <div ref="ansLine" class="power-line-chart"></div>
  </div>
</template>
<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import * as Echarts from 'echarts';

export default {
  name: 'recentMonthCarbon',
  components: {
    pubInfoTitle,
  },
  props: {
    carbonEmissionsData: {
      default: () => {},
      type: Object,
    },
  },
  watch: {
    carbonEmissionsData: {
      handler(val) {
        this.lineChartsInit();
      },
      deep: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.lineChartsInit();
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
  methods: {
    lineChartsInit() {
      this.chart = Echarts.init(this.$refs.ansLine);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let str = `<div>${params[0].name}</div>`;
            params.forEach((item) => {
              str += `<div style='display:flex;'>
                      <div>${item.marker} </div>
                      <div style='width:80px'>${item.seriesName}</div>
                      <div style='font-weight:600;'>${item.value.toFixed(0)}</div>
                    </div>`;
            });
            return str;
          },
        },
        grid: {
          top: this.fitChartSize(30),
          left: '20px',
          right: '10px',
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['5%', '5%'],
          data: this.carbonEmissionsData.index,
          axisTick: {
            show: false, // x 轴刻度是否显示
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#A4A4A4',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(14),
          },
        },
        yAxis: [
          {
            name: 'kg',
            nameLocation: 'end',
            nameTextStyle: {
              color: '#fff',
              align: 'right',
              fontSize: this.fitChartSize(12),
              padding: [0, 6, 0, 0],
            },
            type: 'value',
            axisLabel: {
              color: '#c5c5c5',
              fontSize: this.fitChartSize(12),
              margin: this.fitChartSize(6),
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: 'rgba(43, 196, 255, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            name: '碳减排',
            type: 'line',
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#32BAFF',
              shadowColor: '#32BAFF',
              shadowBlur: 8,
            },
            lineStyle: {
              color: '#65FEE5',
            },
            // 线条下方区域颜色
            areaStyle: {
              color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(101, 255, 230, 1)',
                },
                {
                  offset: 1,
                  color: 'rgba(101, 255, 230, 0)',
                },
              ]),
            },
            data: this.carbonEmissionsData.reduceCarbon,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.recent-month-carbon {
  ::v-deep .pub-info-title {
    margin-bottom: 18px;
  }
  .power-line-chart {
    width: 100%;
    height: 247px;
    margin-bottom: 18px;
  }
}
</style>
